import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { AboutUs, Card } from '@savebetter/components';

import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { RichText, RichTextProps } from './RichText';
import { Section } from './Section';

interface Card extends SbBlokData {
  media: MediaProps[];
  title: string;
  subtitle: string;
  content: RichTextProps;
  isCollapsible: boolean;
}

interface Blok extends PageSectionBlok {
  title: string;
  cards: Card[];
}

interface LeadershipProps extends PageSectionProps {
  blok: Blok;
}

const LeadershipCard: FunctionComponent<React.PropsWithChildren<Card>> = card => {
  const { _uid, media = [], title, subtitle, content, isCollapsible } = card;

  return (
    <Card {...storyblokEditable(card)} className="mb-6 lg:mb-8">
      <AboutUs
        key={_uid}
        text={<RichText content={content} />}
        mediaProps={{ src: media[0].img, alt: media[0].alt, loading: 'lazy' }}
        heading={title}
        subHeading={subtitle}
        addAccordion={isCollapsible}
      />
    </Card>
  );
};

export const Leadership: FunctionComponent<React.PropsWithChildren<LeadershipProps>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, title, cards = [], hasPaddingTop, hasPaddingBottom } = blok;

  return (
    <Section
      width="sm"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader className="pb-6 md:pb-12 lg:pb-14">{title}</PageSectionHeader>
      {cards.map(card => (
        <LeadershipCard {...card} key={card._uid} />
      ))}
    </Section>
  );
};
